import { describeOrbit, EARTH, elementsToState, type OrbitSummary } from '@trajectory/astro';
import type { OrbitalElementsDto } from '@trajectory/contracts';

const DEG_TO_RAD = Math.PI / 180;

/**
 * Runs the API's degrees/metres `OrbitalElementsDto` through the same
 * `@trajectory/astro` physics the server and the future simulation worker
 * use, right here in the browser — this is the whole point of the physics
 * core being plain, DOM-free TypeScript. The Orbit Editor's derived readouts
 * (period, apoapsis/periapsis altitude, speed) are real orbital mechanics,
 * not client-side approximations.
 */
export function summarizeOrbit(dto: OrbitalElementsDto): OrbitSummary {
  const elements = {
    semiMajorAxis: dto.semiMajorAxisMeters,
    eccentricity: dto.eccentricity,
    inclination: dto.inclinationDeg * DEG_TO_RAD,
    raan: dto.raanDeg * DEG_TO_RAD,
    argumentOfPeriapsis: dto.argumentOfPeriapsisDeg * DEG_TO_RAD,
    trueAnomaly: dto.trueAnomalyDeg * DEG_TO_RAD,
  };
  const { position, velocity } = elementsToState(elements, EARTH.mu);
  return describeOrbit(position, velocity, EARTH);
}
